import { render, staticRenderFns } from "./foodType.vue?vue&type=template&id=6f947e93&"
import script from "./foodType.vue?vue&type=script&lang=js&"
export * from "./foodType.vue?vue&type=script&lang=js&"
import style0 from "./foodType.vue?vue&type=style&index=0&id=6f947e93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports